const utils = require('../../../lib/utils')

module.exports = {
    model: {
        // potential fieldConfig values set within cms_templateAtoms.config
        // config: {
        //     sendConfirmationOnChange: true, // should this field be marked as sendConfirmation if the value changes?
        //     separatedFieldCodes: {
        //         mobile: 'mobile',
        //         mobileConfirmed: 'mobileConfirmed',
        //         mobileConfirmedAt: 'mobileConfirmedAt',
        //         mobileConfirmationSentAt: 'mobileConfirmationSentAt',
        //     }
        // }
        dataTEXT: '',
        buttons: [],
    },

    events: {
        performButtonAction: {
            type: 'click',
            selector: 'button, a',
            action: function(event){
                const $target = $(event.target).closest('a, button')
                const fieldType = $target.data('fieldType')
                if($target.length > 0){
                    event.stopImmediatePropagation();

                    if(!$target.is('a[href]')){
                        event.preventDefault()
                        if(fieldType === 'copyToClipboard') {
                            const content = $target.data('content') || ''
                            utils.copyToClipboard(content)
                        } else {
                            // TODO: fancy button actions? maybe performButtonAction method?
                        }
                    }
                }
            }
        },
    },

    methods: {

        prepare(){
            this.initControls()
        },

        initControls(){
            const fieldConfig = this.model.config || {}
            this.model.buttons = []
            for(const button of Object.values(fieldConfig.buttons)){
                this.model.buttons.push({
                    ...(button || {}),
                    symbolOnly:         button.symbolOnly === undefined ? true : button.symbolOnly,
                    preventTabIndex:    button.preventTabIndex === undefined ? true : button.preventTabIndex,
                })
            }
        },

        updateButtons(){
            const dataTEXT = this.model.dataTEXT
            const fieldConfig = this.model.config || {}
            for(const buttonType in fieldConfig.setButtonAttributeOnChange || {}){
                const setAttributes = fieldConfig.setButtonAttributeOnChange[buttonType] || {}
                const $button = this.$.find(`[data-field-type="${buttonType}"]`)
                if($button.length > 0){
                    for(const attributeName in setAttributes){
                        const attributeValue = setAttributes[attributeName]

                        if(dataTEXT){
                            const value = attributeValue.replace('{dataTEXT}', dataTEXT)
                            $button.attr(attributeName, value)
                        } else {
                            $button.removeAttr(attributeName)
                        }
                    }
                }
            }
        }
    },

    hooks: {
        attach($element, options){
            this.updateButtons()
        },

        onChildChanged($element, options){
            this.model.dataTEXT = options.value

            this.updateButtons()

            this.triggerClosest('onChildChanged', options);
        }
    }
}